import {
  Box, LinearProgress, Theme, Typography,
} from '@mui/material';
import React from 'react';

const root = (theme: Theme) => ({
  position: 'absolute',
  top: 0,
  bottom: 0,
  right: 0,
  left: 0,
  backgroundColor: theme.palette.background.paper,
});

const text = (theme: Theme) => ({
  position: 'absolute',
  bottom: theme.spacing(4),
  right: theme.spacing(1),
});

const loading = (theme: Theme) => ({
  position: 'absolute',
  height: theme.spacing(2),
  bottom: theme.spacing(1),
  left: theme.spacing(2),
  right: theme.spacing(2),
  borderRadius: theme.spacing(1),
});

const LoadingPage: React.FC<React.PropsWithChildren<unknown>> = () => (
  <Box sx={root}>
    <Typography variant="h4" color="primary" sx={text}>Loading...</Typography>
    <LinearProgress sx={loading} color="primary" />
  </Box>
);

export default LoadingPage;
